import { gql } from '@apollo/client';

const Fragments = {
  exchangeRate: gql`
    fragment exchangeRate on ExchangeRate {
      exchangeRateId
      currencyCode
      currencyId
      refCurrencyCode
      refCurrencyId
      bankName
      partnerId
      exchangeRateDate
      exchangeRate1
    }
  `
};

export default Fragments;
